import { data } from 'react-router-dom'
import {
  usersLogin,
  createShopper,
  sendOtp,
  verifyOtp,
  Application_form,
  uploadDocuments,
  Application_form2,
  SearchByName,
  getAllocation,
  appliedAllocation,
  getVisitTime,
  applyTask,
  updateDateandTime,
  getReportDetails,
  createReport,
  canceljob,
  scoreCardStep1,
  scoreCardStep3,
  scoreCardStep2,
  deletePhotos,
  inviteallocation,
  requestupdateDateandTime,
  clientsbyDBName,
  clientEntity,
  getAllocationCriteriaDetails,
  getClientEntityByClientGroupId,
  checkInCheckOutShopper,
  fixitlist,
  getquestionquiz,
  createfixit,
  questions,
  scorecardlist,
  getClients,
  getClientEntities,
  getVenueList,
  forgotpassword,
  shopperdetails,
  updateprofileddetails,
  updatebankdetails,
  dashboarddetials,
  bundleallocations,
  applybundleallocations,
  getinvoicelist,
  getinvoiceitem,
  getagreement,
  postsignature,
  pdfdownloadinvoice,
  deleteaccount,
  downloadinvoicepdf,
  getShopType,
  updatefixit,
  getState,
  getrecheck,
  updaterecheck,
  decodetemptoken,
  getEntityType,
  finalacceptbyshopper,
  gettransportbundle,
  applytransportbundle,
  getavailablevenuesfortransport,
  selectevenuefortransport,
  signedstatement,
  digisigner,
  confirminvoice,
  deleteinvitedallocation,
  viewallimages,
  gettrainingslots,
  booktrainingslots,
  cancelbundle,
  getbookedtrainingslots,
  deletebookedtrainingslots,
  getvisittimeselection,
  deleteallocation,
  deleteappliedallocation,
  cancleappliedallocation,
  getstaffManagers,
  getScenarios,
  updateallocationManagerScenario,
  createStaffManager,
  getNewBrief,
  submitQuiz,
  resend2FA
  // getAllRoles,
  // getAdminList,
  // getClientEntities,
  // getUserDetails,
  // postCreateAdmin,
  // putUpdateClient,
  // postCreateClient,
  // getClients,
  // putDeleteClient,
  // putStoreStatus,
  // putUpdateClientEntity,
  // postCreateClientEntity,
  // getEntityTypeList,
  // getVenueList,
  // putVenueStatus,
  // postCreateVenue,
  // putUpdateVenue,
  // putUpdateAdminDetails,
  // putUpdateAdminRole,
  // putUpdateAdminStatus,
  // getShopType,
  // getStarRating,
  // getBriefJson,
  // putUpdateEditors,
  // putVenueEditors
} from './ApiEndPoint.tsx'
import { baseApiCall } from './BaseApiCall.tsx'

  const isAdmin = (localStorage.getItem('liveuserRole') === 'admin' || localStorage.getItem('liveuserRole') === 'superadmin' || localStorage.getItem("liveuserRole") === 'editor' || localStorage.getItem("liveuserRole") === 'clientadmin')

export const ApiUsersLogin = (data: any) => {
  return baseApiCall({
    url: usersLogin,
    method: 'post',
    data
  })
}
export const ApiCreateShopper = (data: any) => {
  return baseApiCall({
    url: createShopper,
    method: 'post',
    data
  })
}
export const ApiResetPassword = (data: any) => {
  return baseApiCall({
    url: forgotpassword,
    method: 'post',
    data
  })
}
export const ApiSendOtp = (data: any) => {
  return baseApiCall({
    url: sendOtp,
    method: 'post',
    data
  })
}
export const ApiVerifyOtp = (data: any) => {
  return baseApiCall({
    url: verifyOtp,
    method: 'post',
    data
  })
}
export const ApisendApplication = (data: any) => {
  return baseApiCall({
    url: Application_form,
    method: 'put',
    data
  })
}
export const ApiuploadDocuments = (data: any) => {
  return baseApiCall({
    url: uploadDocuments,
    method: 'post',
    data,
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  })
}
export const ApisendApplication2 = (data: any) => {
  return baseApiCall({
    url: Application_form2,
    method: 'put',
    data,
  })
}
export const SearchName = (data: any) => {
  return baseApiCall({
    url: SearchByName + data,
    method: 'get',
  })
}
export const fetchAllocations = (params) => {
  return baseApiCall({
    url: getAllocation,
    method: 'get',
    params,
  });
};
export const fetchTransportBundle = (data) => {
  return baseApiCall({
    url: gettransportbundle + data,
    method: 'get',
  });
};
export const ApiApplyTransportBundle = (data) => {
  return baseApiCall({
    url: applytransportbundle,
    method: 'post',
    data
  });
};
export const appliedAllocations = (params, data?: any) => {
  return baseApiCall({
    url: data ? appliedAllocation + data : appliedAllocation,
    method: 'get',
    params,
  });
};
export const getVisitTimes = () => {
  return baseApiCall({
    url: getVisitTime,
    method: 'get',
  });
};
export const applyTasks = (data: any) => {
  return baseApiCall({
    url: applyTask,
    method: 'post',
    data
  });
};
export const UpdateDateTime = (data: any) => {
  return baseApiCall({
    url: updateDateandTime,
    method: 'put',
    data
  })
}

// export const ApiCallCreateReport = (data: any) => {
//   return baseApiCall({
//     url:   createReport,
//     method: 'post',
//     data
//   });
// }

// export const ApiCallGetReportDetails = (data: any) => {
//   return baseApiCall({
//     url: getReportDetails + data,
//     method: 'get',
//   })
// }
export const ApiCancelJob = (data: any) => {
  return baseApiCall({
    url: canceljob,
    method: 'post',
    data
  });
}

// export const ApiScoreCardStep1 = (data: any) => {
//   return baseApiCall({
//     url:   scoreCardStep1,
//     method: 'post',
//     data
//   });
// }

// export const ApiScoreCardStep2 = (data: any) => {
//   return baseApiCall({
//     url:   scoreCardStep2,
//     method: 'post',
//     data
//   });
// }

// export const ApiScoreCardStep3 = (data: any) => {
//   return baseApiCall({
//     url:   scoreCardStep3,
//     method: 'post',
//     data
//   });
// }

export const ApiDeletePhotos = (data: any) => {
  return baseApiCall({
    url: deletePhotos,
    method: 'Delete',
    data
  });
}
export const ApiInviteAllocation = (data:any) => {
  return baseApiCall({
    url: inviteallocation + data,
    method: 'get',
  });
}
export const ApiRequestNewDateTime = (data: any) => {
  return baseApiCall({
    url: requestupdateDateandTime,
    method: 'post',
    data
  })
}
export const ApiGetClientDbName = () => {
  return baseApiCall({
    url: clientsbyDBName,
    method: 'get',
    // data
  })
}
export const ApiGetClientEntity = () => {
  return baseApiCall({
    url: clientEntity,
    method: 'get',
    // data
  })
}

export const ApiGetAllocationCriteriaDetails = (data: any) => {
  return baseApiCall({
    url: getAllocationCriteriaDetails + data,
    method: 'get',
    // data
  })
}
export const ApiGetClientEntityByClientGroupId = (data: any) => {
  return baseApiCall({
    url: getClientEntityByClientGroupId + data,
    method: 'get'
  })
}
export const ApiGetFixitList = (data: any) => {
  return baseApiCall({
    url: fixitlist + data,
    method: 'get'
  })
}
export const ApiUpdateFixit = (data: any) => {
  return baseApiCall({
    url: updatefixit,
    method: 'put',
    data
  })
}
export const ApiCreateFixit = (data: any) => {
  return baseApiCall({
    url: createfixit,
    method: 'post',
    data
  })
}
export const ApiGetQuiz = (data: any) => {
  return baseApiCall({
    url: getquestionquiz + data,
    method: 'get'
  })
}

export const ApiSubmitQuiz = (data: any) => {
  return baseApiCall({
    url: submitQuiz,
    method: 'post',
    data
  })
}

export const ApiGetQuestions = (data: any) => {
  return baseApiCall({
    url: questions + data,
    method: 'get'
  })
}
export const ApiScoreCardList = (data: any) => {
  return baseApiCall({
    url: scorecardlist + data,
    method: 'get'
  })
}
export const ApiGetClients = (data?: any) => {
  return baseApiCall({
    url: getClients + data,
    method: 'get'
  })
}
export const ApiGetClientEntities = (data?: any) => {
  return baseApiCall({
    url: data ? getClientEntities + data : getClientEntities,
    method: 'get',
    data
  })
}
export const ApiGetVenueList = (data: any) => {
  return baseApiCall({
    url: getVenueList + data,
    method: 'get',
    skipLoader: isAdmin ? true : false 
  })
}
export const ApiGetShopperDetails = (data: any) => {
  return baseApiCall({
    url: shopperdetails + data,
    method: 'get'
  })
}
export const ApiUpdateProfiledetails = (data: any) => {
  return baseApiCall({
    url: updateprofileddetails,
    method: 'put',
    data,
  })
}
export const ApiUpdateFinancialDetails = (data: any) => {
  return baseApiCall({
    url: updatebankdetails,
    method: 'put',
    data,
  })
}
export const ApiDashboardDetials = (data: any) => {
  return baseApiCall({
    url: dashboarddetials + data,
    method: 'get',
  })
}
export const ApiBundleAllocations = (params: any) => {
  return baseApiCall({
    url: bundleallocations,
    method: 'get',
    params
  })
}
export const ApiApplyBundleAllocations = (data: any) => {
  return baseApiCall({
    url: applybundleallocations,
    method: 'post',
    data
  })
}
export const ApiGetInvoiceList = (data: any) => {
  return baseApiCall({
    url: getinvoicelist + data,
    method: 'get',
  })
}
export const ApiGetInvoiceItem = (data: any) => {
  return baseApiCall({
    url: getinvoiceitem + data,
    method: 'get',
  })
}
export const ApiConfirmInvoice = (data: any) => {
  return baseApiCall({
    url: `${confirminvoice}/${data}`,
    method: 'get',
  })
}
export const ApiGetAgreement = () => {
  return baseApiCall({
    url: getagreement,
    method: 'get',
  })
}
export const ApiDownloadInvoicepdf= (data) => {
  return baseApiCall({
    url: downloadinvoicepdf+ data,
    method: 'post',
    responseType: 'blob',
    fullResponse: true
  })
}
export const ApiPostSignature = (data: any) => {
  return baseApiCall({
    url: postsignature,
    method: 'post',
    data,
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  })
}
export const ApiDeleteAccount = (data: any, data2:any) => {
  return baseApiCall({
    url: deleteaccount + data,
    method: 'post',
    data:data2
  })
}

export const ApiGetEntityType = (data) => {
  return baseApiCall({
    url: getEntityType + data,
    method: 'get'
  })
}
export const ApiGetStates = (data:any) => {
  return baseApiCall({
    url: getState + data,
    method: 'get'
  })
}


export const ApiGetReCheckList = (data: any) => {
  return baseApiCall({
    url: getrecheck + data,
    method: 'get',
  })
}
export const ApiUpdateReCheckList= (data: any) => {
  return baseApiCall({
    url: updaterecheck,
    method: 'post',
    data
  })
}
export const ApiDecodeTempToken = (data: any) => {
  return baseApiCall({
    url: decodetemptoken,
    method: 'post',
    data
  })
}

export const ApiFinalAcceptedByShopper = (data: any) => {
  return baseApiCall({
    url: finalacceptbyshopper + data,
    method: 'get',
  })
}
export const ApiGetVenueForTransport = (data: any) => {
  return baseApiCall({
    url: getavailablevenuesfortransport + data,
    method: 'get',
  })
}
export const ApiSelectVenueForTransport = (data: any) => {
  return baseApiCall({
    url: selectevenuefortransport,
    method: 'put',
    data
  })
}
export const ApiGetDigisigner= (data: any) => {
  return baseApiCall({
    url: digisigner,
    method: 'post',
    data
  })
}

export const ApiGetSignedStatement= (data: any) => {
  return baseApiCall({
    url: signedstatement + data,
    method: 'get',
  })
}

export const ApiDeleteInvitedAllocation= (data: any) => {
  return baseApiCall({
    url: deleteinvitedallocation + data,
    method: 'delete',
  })
}
export const ApiGetAllImages= (data: any) => {
  return baseApiCall({
    url: viewallimages + data,
    method: 'get',
  })
}
export const ApiGetTrainingSlots= (data: any) => {
  return baseApiCall({
    url: gettrainingslots + data,
    method: 'get',
  })
}
export const ApiBookTrainingSlots= (data: any) => {
  return baseApiCall({
    url: booktrainingslots,
    method: 'post',
    data
  })
}
export const ApiCancelBundle = (data: any) => {
  return baseApiCall({
    url: cancelbundle,
    method: 'post',
    data
  })
}
export const ApiGetBookedTrainings= (data: any) => {
  return baseApiCall({
    url: getbookedtrainingslots + data,
    method: 'get',
  })
}
export const ApiDeleteBookedTrainings= (data: any) => {
  return baseApiCall({
    url: deletebookedtrainingslots,
    method: 'post',
    data
  })
}
export const APiGetTimeSelection = (data: any) => {
  return baseApiCall({
    url: getvisittimeselection + data,
    method: 'get',
  })
}

export const ApiDeleteAllocation = (data: any) => {
  return baseApiCall({
    url: deleteallocation + data,
    method: 'delete',
  })
}

export const ApiDeleteAppliedAllocation = (data: any) => {
  return baseApiCall({
    url: deleteappliedallocation + data,
    method: 'delete',
  })
}

export const ApiCancelAppliedAllocation = (data: any) => {
  return baseApiCall({
    url: cancleappliedallocation,
    method: 'post',
    data
  })
}

export const ApiGetStaffManagers = (data: any) => {
  return baseApiCall({
    url: getstaffManagers + data,
    method: 'get',
  })
}
export const ApiGetScenarios = (data: any) => {
  return baseApiCall({
    url: getScenarios + data,
    method: 'get',
  })

}

export const ApiUpdateCommunication = (data: any) => {
  return baseApiCall({
    url: updateallocationManagerScenario ,
    method: 'post',
    data,
  })
}

export const ApiCreateStaffManager = (data: any) => {
  return baseApiCall({
    url: createStaffManager,
    method: 'post',
    data
  })
}

export const ApiGetNewBrief = (data: any) => {
  return baseApiCall({
    url: getNewBrief + data,
    method: 'get',
  })

}

export const ApiGetResend2FA = (data: any) => {
  return baseApiCall({
    url: resend2FA,
    method: 'post',
    data
  })

}